import h from 'hyperscript';

export default h('.pswp', {
  attrs: {
    tabindex: '-1',
    role: 'dialog',
    'aria-hidden': 'true',
  },
}, h('.pswp__bg'), h('.pswp__scroll-wrap',
  h('.pswp__container',
    h('.pswp__item'),
    h('.pswp__item'),
    h('.pswp__item'),
  ),
  h('.pswp__ui.pswp__ui--hidden',
    h('.pswp__top-bar',
      h('.pswp__counter'),
      h('button.pswp__button.pswp__button--close', { title: 'Schließen (Esc)' }),
      h('.pswp__preloader',
        h('.pswp__preloader__icn',
          h('.pswp__preloader__cut',
            h('.pswp__preloader__donut'),
          ),
        ),
      ),
    ),
    h('button.pswp__button.pswp__button--arrow--left', { title: 'Vorheriges Bild (Pfeil links)' }),
    h('button.pswp__button.pswp__button--arrow--right', { title: 'Nächstes Bild (Pfeil rechts)' }),
    h('.pswp__caption',
      h('.pswp__caption__center'),
    ),
  ),
));



// WEBPACK FOOTER //
// ./src/javascripts/shared/photoswipe-template.js